import { useEffect } from "react";
import { FallbackProps } from "react-error-boundary";
import Button from "@scripts/react/components/Button";
import raccoonBurntOut from "../../public/images/lenny-burnt-out.png";

export const CrashScreen = ({ error, resetErrorBoundary }: FallbackProps) => {
    useEffect(() => {
        // TODO(japrescott, 2025-09-05): we should be calling sentry or something here
    }, []);
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="mx-4 w-[480px] rounded-lg bg-white p-6 shadow-xl">
                <div className="mb-4 flex items-center">
                    <div className="mr-3 flex h-8 w-8 items-center justify-center rounded-full bg-red-100">
                        <svg
                            className="h-4 w-4 text-red-600"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                        >
                            <path
                                fillRule="evenodd"
                                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                clipRule="evenodd"
                            />
                        </svg>
                    </div>
                    <h3 className="text-lg font-medium text-gray-900">
                        Woops, something went wrong
                    </h3>
                </div>
                <img src={raccoonBurntOut} alt="Raccoon burnt out" />
                <p className="mb-4 text-sm text-gray-600">
                    An unexpected error occurred. Please try again.
                </p>
                <details className="mb-4">
                    <summary className="cursor-pointer text-sm text-gray-500 hover:text-gray-700"></summary>
                    <div className="mt-2 rounded bg-gray-100 p-3">
                        <pre className="max-h-32 overflow-auto text-xs text-gray-800">
                            {error.message}
                            {error.stack && (
                                <>
                                    {"\n\n"}
                                    {error.stack}
                                </>
                            )}
                        </pre>
                    </div>
                </details>
                <div className="flex justify-end space-x-3">
                    <Button type="primary" className="!h-auto py-3" onClick={resetErrorBoundary}>
                        Try again
                    </Button>
                </div>
            </div>
        </div>
    );
};
